import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-previous',
  templateUrl: './previous.component.html',
  styleUrls: ['./previous.component.styl']
})
export class PreviousComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
